import Vue from 'vue';
import Vuex from 'vuex';

import users from './modules/users';
import contracts from './modules/contracts';
import auth from './modules/auth';
import vacations from './modules/vacations';
import holidays from './modules/holidays';
import notification from './modules/notification';
import settings from './modules/settings';
import versions from './modules/versions';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        users,
        contracts,
        vacations,
        holidays,
        notification,
        settings,
        versions
    }
});
